module.exports = __webpack_public_path__ + "static/img/12.4784dfd2.png";